import { useState } from "react";
import { Camera, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { resizeToBase64 } from "@/lib/nutri";

export const PhotoTab = ({ meal, date, onDone }) => {
  const [preview, setPreview] = useState(null);
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    setItems(null);
    try {
      const b64 = await resizeToBase64(file);
      setPreview(b64);
      const { data } = await api.post("/nutri/analyze-photo", { image_base64: b64 });
      const list = Array.isArray(data?.items) ? data.items : [];
      setItems(list.map((it) => ({ ...it, on: true })));
      if (!list.length) toast.info("Nessun alimento riconosciuto. Prova un'altra foto.");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  const toggle = (i) => setItems((cur) => cur.map((it, j) => (j === i ? { ...it, on: !it.on } : it)));

  const addAll = async () => {
    const sel = items.filter((i) => i.on);
    try {
      await Promise.all(sel.map(({ on, ...it }) => api.post("/nutri/entries", { ...it, date, meal, source: "photo" })));
      toast.success(`${sel.length} alimenti aggiunti`);
      onDone();
    } catch (err) {
      toast.error(formatError(err));
    }
  };

  return (
    <div className="space-y-4 pt-4">
      <label data-testid="photo-upload-label" className="relative grid aspect-video cursor-pointer place-items-center overflow-hidden border border-dashed border-[rgba(152,191,162,0.4)] bg-[#050807] hover:border-[#c4dcca]">
        {preview ? <img src={preview} alt="Foto piatto" className="absolute inset-0 h-full w-full object-cover opacity-70" /> : null}
        <span className="relative flex flex-col items-center gap-2 font-mono text-xs uppercase tracking-widest">
          {loading ? <Loader2 className="animate-spin" /> : <Camera />}
          {loading ? "Analisi in corso…" : preview ? "Cambia foto" : "Scatta o carica una foto"}
        </span>
        <input data-testid="photo-upload-input" type="file" accept="image/*" capture="environment" className="hidden" onChange={onFile} disabled={loading} />
      </label>
      {items?.length > 0 && (
        <div data-testid="photo-results" className="space-y-2">
          <p className="font-mono text-[11px] uppercase tracking-widest text-[#a3b1aa]">Stima AI · controlla prima di aggiungere</p>
          {items.map((it, i) => (
            <button key={i} type="button" data-testid={`photo-item-${i}`} onClick={() => toggle(i)}
              className={`flex w-full items-center justify-between border px-3 py-2.5 text-left ${it.on ? "border-[#98bfa2]" : "border-white/10 opacity-50"}`}>
              <span className="text-sm">{it.name} <span className="font-mono text-xs text-[#a3b1aa]">· {Math.round(it.grams)} g</span></span>
              <span className="font-mono text-xs">{Math.round(it.kcal)} kcal</span>
            </button>
          ))}
          <button data-testid="photo-add-btn" disabled={!items.some((i) => i.on)} onClick={addAll}
            className="w-full bg-[#98bfa2] py-3 font-display text-lg font-800 uppercase text-[#050807] hover:bg-[#c4dcca] disabled:opacity-50">
            Aggiungi selezionati
          </button>
        </div>
      )}
    </div>
  );
};
